export default __webpack_public_path__ + "static/media/ic.37b39ca7.svg";